import React from "react";

const HomeForm: React.FC<{
  newHomeValue: string;
  setNewHomeValue: React.Dispatch<React.SetStateAction<string>>;
  closeModal: () => void;
  handleSubmit(e: React.FormEvent<HTMLFormElement>): void;
}> = ({ newHomeValue, setNewHomeValue, closeModal, handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-create-body-inner">
        <div className="modal-input-container">
          <label htmlFor="home-name" data-testid="create-home-name">
            Home Name
          </label>
          <input
            className="modal-input"
            name="home-name"
            value={newHomeValue}
            onChange={(e) => setNewHomeValue(e.target.value)}
          />
        </div>
      </div>
      <div className="margin-bottom-small" />
      <div className="modal-input-actions">
        <button
          type="button"
          className="tertiary-btn-small"
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          disabled={newHomeValue === ""}
          type="submit"
          className="tertiary-btn-small user-card-action-btn user-card-action-btn-resend"
        >
          Confirm
        </button>
      </div>
    </form>
  );
};

export default HomeForm;
